import {
	requests
}from "../../../api/agent"

export default {
	getPaged       : (params) => requests.post('/reConstructionMaterialPeriodPrice/getPaged', params),
	getExampleFile : () => requests.getFile('/reConstructionMaterialPeriodPrice/getExampleFile'),
	uploadPrices   : (params) => requests.post('/reConstructionMaterialPeriodPrice/uploadPrices', params)
}